import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3Wide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="columns-3-wide, layout, third"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.87891 5V19" stroke="currentColor" strokeWidth="1.5"/><path d="M15.1211 5V19" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconColumns3Wide;
